import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface INavigatorToolbarProps extends IBaseProps {
  showBackIcon?: boolean;
  title: string | React.ReactElement | null;
  onNavigatorClick?: () => void;
}

const NavigatorToolbar: React.FC<INavigatorToolbarProps> = (props) => {
  const { style, className, showBackIcon = true, title, onNavigatorClick } = props;

  return (
    <div
      style={style}
      className={classnames('dbg-navigator-toolbar', className, { 'dbg-navigator-toolbar--has-back': showBackIcon })}
      onClick={(e) => {
        e?.stopPropagation();
        onNavigatorClick?.();
      }}
    >
      {showBackIcon && <div className="dbg-navigator-toolbar__icon"></div>}
      <div className="dbg-navigator-toolbar__title">
        <span>{title}</span>
      </div>
    </div>
  );
};

export default NavigatorToolbar;
